var map = {
	"./accrued.svg": "a21b",
	"./accruedAdmin.svg": "d76d",
	"./accruedDomonetization.svg": "01ba",
	"./approve.svg": "440d",
	"./approveClean.svg": "f798",
	"./arrowStatus.svg": "c2ee",
	"./averageMoneyCommission.svg": "cb28",
	"./commission.svg": "5d93",
	"./commissionDomonetization.svg": "c2a7",
	"./commissionLeads.svg": "e14d",
	"./filteredLeads.svg": "4f7e",
	"./leadCancelled.svg": "821c",
	"./leadConfirmed.svg": "8a3f",
	"./leadIntegrated.svg": "b607",
	"./leadProcessed.svg": "e0e0",
	"./leadSpamByAdvertiser.svg": "29f6",
	"./leadTrash.svg": "9baa",
	"./leads.svg": "e8d9",
	"./leadsFilteredSpam.svg": "50d4",
	"./leadsHold.svg": "bd20",
	"./moneyConfirmed.svg": "77ef",
	"./redemption.svg": "306b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bd94";